/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Contact_EmailInputs */

const he_help_contact_email = /** @type {(inputs: Help_Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלחו אלינו מייל`)
};

const en_help_contact_email = /** @type {(inputs: Help_Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email us at`)
};

/**
* | output |
* | --- |
* | "Email us at" |
*
* @param {Help_Contact_EmailInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const help_contact_email = /** @type {((inputs?: Help_Contact_EmailInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Contact_EmailInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_contact_email(inputs)
	return en_help_contact_email(inputs)
});